export const NON_EU_MAJOR = new Set([
    'US', 'CN', 'JP', 'KR', 'IN', 'BR', 'RU', 'CA', 'AU', 'NZ',
    'MX', 'AR', 'CL', 'ZA', 'IL', 'TR', 'SA', 'AE', 'SG',
]);